module.exports = __webpack_public_path__ + "img/chevron-left.d619e990.svg";